export const buyers = [
  { name: 'Valentina R.', place: 'Bogotá, Colombia', minutes: 2 },
  { name: 'Dr. Alejandro M.', place: 'Ciudad de México, Mexico', minutes: 4 },
  { name: 'Camila G.', place: 'Buenos Aires, Argentina', minutes: 1 },
  { name: 'Dr. Javier L.', place: 'Madrid, Spain', minutes: 6 },
  { name: 'Daniela P.', place: 'Santiago, Chile', minutes: 3 },
  { name: 'Dr. Andrés F.', place: 'Lima, Peru', minutes: 8 },
  { name: 'Sofía H.', place: 'Montevideo, Uruguay', minutes: 5 },
  { name: 'Dr. Mateo V.', place: 'Quito, Ecuador', minutes: 2 },
  { name: 'Lucía C.', place: 'San José, Costa Rica', minutes: 7 },
  { name: 'Dr. Ricardo S.', place: 'Santo Domingo, Dominican Republic', minutes: 3 },
  { name: 'Isabella T.', place: 'Asunción, Paraguay', minutes: 9 },
  { name: 'Dr. Fernando A.', place: 'Panama City, Panama', minutes: 4 },
  { name: 'Mariana D.', place: 'Guadalajara, Mexico', minutes: 1 },
  { name: 'Dr. Gabriel N.', place: 'San Juan, Puerto Rico', minutes: 6 },
];
